import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { _ } from '../../functions/translator.js';
import { Checkbox } from '@material-ui/core';
import { hasElementsMatch } from '../../functions/finder';
import { FilterActions } from '../../constants/constants.js';

class ProtocolDropdown extends React.Component{

    handleProtocolGroupChange = event => {
        this.props.filterChange(FilterActions.PROTOCOLGROUPS, event.target.value);
    };

    handleSelected = (selected) => {
        if (selected.length === 0) {
            return _('Protocolos');
        } else {
            let protocolgroupNames = []
            for (const categoryId of selected) {
                let protocolgroupData = this.props.protocolgroupsData[categoryId.toString()]
                protocolgroupNames.push(protocolgroupData.attributes.name)
            }
            return protocolgroupNames.join(', ')
        }
    }

    hasALevelMatch(protocolsData) {
        for (const protocolId in protocolsData) {
            if (hasElementsMatch(this.props.levelIds, this.props.matches.levels_protocols, parseInt(protocolId))) {
                return true
            }
        }
        return false
    }

    hasACategoryMatch(protocolsData) {
        for (const protocolId in protocolsData) {
            if (hasElementsMatch(this.props.cardCategoryIds, this.props.matches.card_categories_protocols, parseInt(protocolId))) {
                return true
            }
        }
        return false
    }

    componentDidUpdate(prevProps) {
        if (prevProps.levelIds !== this.props.levelIds || prevProps.cardCategoryIds !== this.props.cardCategoryIds) {
            let protocolgroupIds = []
            for (const protocolgroupId of this.props.protocolgroupIds) {
                let protocolgroupData = this.props.protocolgroupsData[protocolgroupId.toString()]
                let protocols = protocolgroupData.protocols
                if (this.hasALevelMatch(protocols) && this.hasACategoryMatch(protocols)) {
                    protocolgroupIds.push(protocolgroupId)
                }
            }
            if (protocolgroupIds.length !== this.props.protocolgroupIds.length) {
                this.props.filterChange(FilterActions.PROTOCOLGROUPS, protocolgroupIds)
            }
        }
    }

    render() {
        let stageProtocolgroupIds = []
        for (const stageData of Object.values(this.props.stagesData)) {
            if (this.props.stageIds.length > 0 && !this.props.stageIds.includes(stageData.id)) continue
            stageProtocolgroupIds = stageProtocolgroupIds.concat(
                Object.values(stageData.protocols).map((protocol) => { return protocol.attributes.protocolgroup_id })
            )
        }
        
        const options = []
        for (const protocolGroup of Object.values(this.props.protocolgroupsData)) {
            if (stageProtocolgroupIds.includes(protocolGroup.id)
                && this.hasALevelMatch(protocolGroup.protocols)
                && this.hasACategoryMatch(protocolGroup.protocols)){
                options.push(
                    <MenuItem key={protocolGroup.id} value={protocolGroup.id}>
                        <Checkbox color="primary" checked={this.props.protocolgroupIds.includes(protocolGroup.id)} />
                        {protocolGroup.attributes.name}
                    </MenuItem>
                )
            }
        }

        return(
            <div>
                <Select
                value={this.props.protocolgroupIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.handleSelected}
                onChange={this.handleProtocolGroupChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {options}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        stageIds           : state.filters.stageIds,
        levelIds           : state.filters.levelIds,
        cardCategoryIds    : state.filters.cardCategoryIds,
        protocolgroupIds   : state.filters.protocolgroupIds,
        appartmentIds      : state.filters.appartmentIds,
        stagesData         : state.projectData.stages,
        protocolgroupsData : state.projectData.protocolgroups,
        matches            : state.matches
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ProtocolDropdown);